import styled from 'styled-components';
import MaterialAvatar from '@material-ui/core/Avatar';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { white } from 'constants/colors';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const UserCardWrapper = styled.div`
  max-height: 100%;
  max-width: 100%;
  overflow-y: scroll;
  background-color: ${props => props.color};
  font-size: 0;
  padding: 10px;
`;

export const NoData = styled.div`
  width: 80%;
  background-color: white;
  color: ${props => props.color};
  font-size: 1.8rem;
  text-align: center;
  border-radius: 2rem;
  padding: 2rem;
  margin: 2rem auto;

  @media (max-width: ${TABLET_WIDTH}px) {
    font-size: 1.4rem;
    padding: 1rem;
  }
`;

export const Close = styled.div`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  text-align: center;
  line-height: 20px;
  background-color: #fff;
  border-radius: 50%;
  padding-top: 4px;
  z-index: 10;

  i {
    font-size: 12px;
    color: #4d4d4d;
  }
`;

export const ButtonEditResume = styled.button`
  margin: 0 10px;
  border-radius: 20px;
  text-align: center;
  padding: 7px;
  font-size: 14px;
  width: 140px;
  border: 1px solid #64DD17;
  color: #fff;
  background-color: #64DD17;
  margin: 10px auto;
`;

export const AvatarWrapper = styled.div`
  position: relative;
`;

export const UserAvatar = styled(MaterialAvatar)`
   && {
    width: 120px;
    height: 120px;
    display: inline-block;

    &.text-avatar {
      font-size: 72px;
      padding-top: 20px;
    }
   }
`;

export const UserName = styled.div`
  color: ${white};
  font-size: 20px;
  line-height: 30px;
  font-weight: bold;
  margin-top: 10px;
`;

export const MainButtons = styled.div`
  text-align: center;
  margin: 20px 0;

  button {
    margin: 0 10px;
    border-radius: 20px;
    text-align: center;
    width: 39%;
    padding: 7px;
    font-size: 14px;
    max-width: 140px;
  }
`;

export const ButtonNormal = styled.button`
  border: 1px solid #aaa;
  color: #666;
  background-color: #fff;
`;

export const ButtonSuccess = styled.button`
  border: 1px solid #558B2F;
  color: #fff;
  background-color: #558B2F;
`;

export const ButtonDanger = styled.button`
  border: 1px solid #F44336;
  color: #fff;
  background-color: #F44336;
`;

export const ProfileTabs = styled.div`
  background-color: rgba(0, 0, 0, 0.05);
`;


export const ProfileTab = styled.div`
  width: calc(100% / 3);
  display: inline-block;
  text-align: center;
  padding: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;

  ${props => (props.active ? 'border-bottom: 2px solid #fff' : '')};

`;

export const TabContent = styled.div`
  width: 90%;
  margin: 0 auto;
`;

export const ProfileSection = styled.div`
  text-transform: uppercase;
  color: #fff;
  font-family: 'helvetica neue';
  font-size: 11px;
  margin-bottom: 20px;
  text-align: left;
  margin-top: 30px;
  border-bottom: 1px solid #fff;
  padding-bottom: 3px;
`;

export const ProfileContent = styled.div`
  background-color: ${props => props.color};
  > div {
    color: #fff;
  }
`;

export const ProfileAnswer = styled.div`
  font-size: 12px;
  margin: 10px 0 20px;
  text-align: left;
`;

export const RelationsList = styled.div`

`;

export const RelationWrapper = styled.div`
  &.hidden {
    display: none;
  }
`;

export const NoRelations = styled.div`
  color: ${white};
  font-size: 16px;
  margin-top: 25px;
`;

export const ActionWrapper = styled.div`
  padding: 12px 0;
  border-radius: 5px;
  margin-bottom: 10px;

  && {
    position: relative;
    max-width: 100%;
    width: 100%;

    .slide {
      background: none !important;

      iframe {
        display: block;
        width: 100%;
        margin: 0 0px 20px;
        border: 0;
      }
    }
  }
`;

export const ConnectionsWrapper = styled.div`
  margin-top: 20px;

  .slide {
    background: none !important;
  }

  .slick-dots {
    margin: -15px 0 15px;
  }
`;

export const ProfileSectionTitle = styled.div`
  color: #fff;
  font-family: 'helvetica neue';
  font-size: 11px;
  text-transform: uppercase;
  display: inline-block;
  max-width: 90%;
  vertical-align: middle;
`;

export const NarrativeTitle = styled.div`
  color: ${props => props.color};
  font-size: 14px;
  background-color: #fff;
  text-align: left;
  padding: 3px;
  margin: 20px auto -15px 0;
  display: block;
  font-weight: 600;
  min-width: 50px;
  width: auto;
  font-family: 'helvetica neue';
`;

export const NarrativeQuestions = styled.div`
  padding: 10px;
  background-color: rgba(255,255,255,0.2);
`;

export const TextLabel = styled(InputLabel)`
  && {
    text-align: left;
    font-size: 1.6rem;
    color: #ecf0f1;
    transform: scale(0.75);
    display: block;
    margin-bottom: 0px !important;
  }
`;

export const Combobox = styled(Select)`
  && {

    ::before {
      border-bottom: 0px;
    }

    .form__field__input {
      text-align: left;
      border-bottom: solid 1px #ecf0f1;
    }

    svg {
      color: #ecf0f1;
    }

    option {
      color: #444;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Steps/UserCard/components/styles.js